import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { ContractingCorporationProfileHeader } from './_layout/-components/Header';
export const Route = createFileRoute('/_staff/settings/contracting-corporation-profile/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  return <VStack className="gap-0">
      <ContractingCorporationProfileHeader />
      <Outlet />
    </VStack>;
}